import { PageHeader as PageHeaderAntd } from 'antd';
import styled from 'styled-components';

export const PageHeader = styled(PageHeaderAntd)`
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
`;
